import { useLanguage } from '@/context/LanguageContext'
import { SDG } from '@/services/cms-api/home-page-content/types'
import { resolveImageUrl } from '@/utils/constants'
import useIntl from '@/utils/intl'
import { useRouter } from 'next/navigation'
import React, { FunctionComponent } from 'react'

interface Prop {
  data: SDG[]
}

const Sdg: FunctionComponent<Prop> = ({ data }) => {
  const router = useRouter()
  const { locale } = useLanguage()
  const { translate } = useIntl()

  if (data === undefined || data === null) {
    return <></>
  }

  return (
    <div id='sdg' className='w-full flex justify-center lg:mt-12 md:mt-0 mt-12'>
      <div className='bg-surfaceWebGrey rounded-xl h-full flex flex-col items-center justify-center lg:py-20 py-12 lg:px-[72px] px-5 shadow-[inset_0_0_12px_0_rgba(0,0,0,0.12)] w-[95vw]'>
        <span className='2xl:text-5xl xl:text-4xl text-3xl text-textHigh font-extrabold text-center'>{translate('sdg.title')}</span>
        {/* <span className='2xl:text-5xl xl:text-4xl text-3xl text-[#3B3E43] font-extrabold text-center'>Бид тогтвортой <span className='text-[#F87171]'>хөгжлийн</span> төлөө</span> */}
        <div className='flex gap-6 xl:mt-14 mt-8 flex-col md:flex-row w-full justify-center items-center'>
          {data.map((item: SDG, i: number) => (
            <div
              id={'sdg.' + item.id.toString()}
              key={i}
              className='group/item cursor-pointer bg-center bg-cover 2xl:w-[400px] 2xl:h-[433px] xl:w-[330px] xl:h-[363px] lg:w-[267px] lg:h-[300px] md:w-[200px] md:h-[233px] w-full h-auto 2xl:hover:w-[570px] xl:hover:w-[450px] lg:hover:w-[335px] md:hover:w-[300px] transition-all duration-500 rounded-2xl'
              style={{ backgroundImage: `url(${resolveImageUrl(item.image)})` }}
              onClick={() => router.push('/sdg')}
            >
              <div className='group/edit h-full bg-gradient-to-t md:from-black/50 px-6 rounded-2xl flex flex-col justify-end md:group-hover/item:from-black from-black'>
                <div className='group/edit md:group-hover/item:-translate-y-6 md:translate-y-0 -translate-y-6 transition-all duration-500 mt-40 md:mt-0'>
                  <span className='text-textAdditional font-bold 2xl:text-xl xl:text-base text-sm'>{locale === 'en' ? item.titleEn : item.titleMn}</span>
                  <hr className='border-white/25 xl:my-4 my-3' />
                  <p className='2xl:w-[500px] xl:w-[400px] lg:w-[280px] md:w-[250px] text-[#B0B0B0] font-semibold md:hidden group/edit md:group-hover/item:flex flex xl:text-sm text-xs'>{locale === 'en' ? item.descriptionEn : item.descriptionMn}</p>
                </div>
              </div>
            </div>
          ))}

        </div>
      </div>
    </div>
  )
}
export default Sdg
